import {SortableHandle} from 'react-sortable-hoc';
import * as React from 'react';
export default SortableHandle(() => (
	<span className="drag-handle">
		<span className="symbol">⋮⋮</span>
	</span>
));
